var segmentedControlItemSlot = 'fx_2d2fb1e5_14ctvoz0';

export { segmentedControlItemSlot };
//# sourceMappingURL=itemSlot.vanilla.mjs.map
